import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import SkeletonTable from "../../components/table/SkeletonTable";
import columns from "../../columns/payroll/employeePayrollHistory";
import { EmployeePayrollHistory } from "../../api/request/payroll/payroll";
import { toast } from "react-hot-toast";
import LeftArrow from "../../assets/LeftArrow";
import { Card } from "antd";
import { ReactComponent as Email } from "../../assets/email.svg";
import { ReactComponent as User } from "../../assets/User.svg";

const ViewPayrollHistory = () => {
  const { id } = useParams();
  const { state } = useLocation();
  const navigate = useNavigate();
  const [employeeHistory, setEmployeeHistory] = useState([]);
  const [employeeLoading, setEmployeeLoading] = useState(false);

  const handleViewHistory = async () => {
    if (!id) return;
    try {
      setEmployeeLoading(true);
      const { data } = await EmployeePayrollHistory({
        employee_id: id,
      });
      if (data?.status) {
        setEmployeeHistory(
          data?.data?.map((item) => {
            return {
              ...item,
              status: (
                <p
                  className={`${
                    item?.status === "entered"
                      ? "text-green-500"
                      : "text-red-600"
                  } font-bold capitalize`}
                >
                  {item?.status}
                </p>
              ),
            };
          })
        );
      }
    } catch (error) {
      if (error?.response?.data?.message)
        toast?.error(error?.response?.data?.message);
    } finally {
      setEmployeeLoading(false);
    }
  };

  useEffect(() => {
    handleViewHistory();
  }, [id]);

  const { name, email, contact_no } = state?.employee || {};

  return (
    <div className="border rounded-xl bg-white">
      <div className="flex justify-between gap-3">
        <div className="flex items-center gap-3 mx-5 my-5">
          <button
            onClick={() => navigate("/payroll")}
            className="text-secondary"
          >
            <LeftArrow />
          </button>
          <p className="title">
            View Payroll History{" "}
            {employeeHistory?.length ? `(${employeeHistory?.length})` : ""}
          </p>
        </div>

        <div className="flex items-center space-x-3">
          <div className="mx-5 my-5">
            <p className="text-sm text-gray-600 flex items-center mb-1">
              <User className="mr-1 size-5" /> {name}
            </p>
            <p className="text-sm text-gray-600 flex items-center">
              <Email className="mr-1 size-5" /> {email}
            </p>
          </div>
        </div>
      </div>
      <SkeletonTable
        columns={columns}
        data={employeeHistory || []}
        isLoading={employeeLoading}
      />
    </div>
  );
};

export default ViewPayrollHistory;
